'use client';

import Link from 'next/link';
import Image from 'next/image';
import { Button } from '@/components/ui/button';
import { Menu, X } from 'lucide-react';
import { useState } from 'react';

export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav data-zylo-id="zylo-845a96474a4d" data-zylo-kind="container" data-zylo-cap="247" data-zylo-file="src/components/navbar.tsx" data-zylo-loc="13:5-95:11" data-zylo-component="Navbar" className="sticky top-0 z-50 bg-white border-b border-border shadow-sm">
      <div data-zylo-id="zylo-68626e5ce362" data-zylo-kind="container" data-zylo-cap="247" data-zylo-file="src/components/navbar.tsx" data-zylo-loc="14:7-94:13" data-zylo-component="Navbar" className="container mx-auto px-4 sm:px-6 py-4">
        <div data-zylo-id="zylo-97f3cef17ad8" data-zylo-kind="container" data-zylo-cap="247" data-zylo-file="src/components/navbar.tsx" data-zylo-loc="15:9-59:15" data-zylo-component="Navbar" className="flex items-center justify-between">
          {/* Logo */}
          <Link data-zylo-id="zylo-31f964d18b6c" data-zylo-kind="link" data-zylo-cap="26" data-zylo-file="src/components/navbar.tsx" data-zylo-loc="17:11-22:18" data-zylo-component="Navbar" href="/" className="flex items-center gap-2 font-bold text-2xl text-primary">
            <div data-zylo-id="zylo-f4cd6139dd49" data-zylo-kind="container" data-zylo-cap="247" data-zylo-file="src/components/navbar.tsx" data-zylo-loc="18:13-20:19" data-zylo-component="Navbar" className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center text-white">
              ⚓
            </div>
            Blue Kraken
          </Link>

          {/* Desktop Menu */}
          <div data-zylo-id="zylo-3dd945d67b49" data-zylo-kind="container" data-zylo-cap="247" data-zylo-file="src/components/navbar.tsx" data-zylo-loc="25:11-38:17" data-zylo-component="Navbar" className="hidden md:flex items-center gap-8">
            <Link data-zylo-id="zylo-04d2c1b61d50" data-zylo-kind="link" data-zylo-cap="26" data-zylo-file="src/components/navbar.tsx" data-zylo-loc="26:13-28:20" data-zylo-component="Navbar" href="/detailing" className="text-foreground hover:text-primary transition-colors font-medium">
              Auto Detailing
            </Link>
            <Link data-zylo-id="zylo-20e9097ab408" data-zylo-kind="link" data-zylo-cap="26" data-zylo-file="src/components/navbar.tsx" data-zylo-loc="29:13-31:20" data-zylo-component="Navbar" href="/inspections" className="text-foreground hover:text-primary transition-colors font-medium">
              Home Inspections
            </Link>
            <Link data-zylo-id="zylo-1af6aa449ec7" data-zylo-kind="link" data-zylo-cap="26" data-zylo-file="src/components/navbar.tsx" data-zylo-loc="32:13-34:20" data-zylo-component="Navbar" href="/about" className="text-foreground hover:text-primary transition-colors font-medium">
              About
            </Link>
            <Link data-zylo-id="zylo-35790cb57c67" data-zylo-kind="link" data-zylo-cap="26" data-zylo-file="src/components/navbar.tsx" data-zylo-loc="35:13-37:20" data-zylo-component="Navbar" href="/contact" className="text-foreground hover:text-primary transition-colors font-medium">
              Contact
            </Link>
          </div>

          {/* Desktop CTA */}
          <div data-zylo-id="zylo-43b97dea13cd" data-zylo-kind="container" data-zylo-cap="247" data-zylo-file="src/components/navbar.tsx" data-zylo-loc="41:11-45:17" data-zylo-component="Navbar" className="hidden md:flex gap-3">
            <Button data-zylo-id="zylo-0d6dd1e24188" data-zylo-kind="container" data-zylo-cap="247" data-zylo-file="src/components/navbar.tsx" data-zylo-loc="42:13-44:22" data-zylo-component="Navbar" variant="outline" asChild>
              <Link data-zylo-id="zylo-3a275fdb52da" data-zylo-kind="link" data-zylo-cap="26" data-zylo-file="src/components/navbar.tsx" data-zylo-loc="43:15-43:56" data-zylo-component="Navbar" href="/contact">Get in Touch</Link>
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button data-zylo-id="zylo-19fb18de2296" data-zylo-kind="button" data-zylo-cap="126" data-zylo-file="src/components/navbar.tsx" data-zylo-loc="48:11-58:20" data-zylo-component="Navbar"
            className="md:hidden p-2"
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle menu"
          >
            {isOpen ? (
              <X data-zylo-id="zylo-490702cbc99e" data-zylo-kind="icon" data-zylo-cap="86" data-zylo-file="src/components/navbar.tsx" data-zylo-loc="54:15-54:40" data-zylo-component="Navbar" className="w-6 h-6" />
            ) : (
              <Menu data-zylo-id="zylo-3debc730e4d5" data-zylo-kind="icon" data-zylo-cap="86" data-zylo-file="src/components/navbar.tsx" data-zylo-loc="56:15-56:43" data-zylo-component="Navbar" className="w-6 h-6" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div data-zylo-id="zylo-db4306fc8b1d" data-zylo-kind="container" data-zylo-cap="247" data-zylo-file="src/components/navbar.tsx" data-zylo-loc="63:11-92:17" data-zylo-component="Navbar" className="md:hidden mt-4 pb-4 space-y-3 border-t border-border pt-4">
            <Link data-zylo-id="zylo-b55cf6f28e4d" data-zylo-kind="link" data-zylo-cap="26" data-zylo-file="src/components/navbar.tsx" data-zylo-loc="64:13-70:20" data-zylo-component="Navbar"
              href="/detailing"
              className="block py-2 text-foreground hover:text-primary transition-colors font-medium"
              onClick={() => setIsOpen(false)}
            >
              Auto Detailing
            </Link>
            <Link data-zylo-id="zylo-f065ae2e8129" data-zylo-kind="link" data-zylo-cap="26" data-zylo-file="src/components/navbar.tsx" data-zylo-loc="71:13-77:20" data-zylo-component="Navbar"
              href="/inspections"
              className="block py-2 text-foreground hover:text-primary transition-colors font-medium"
              onClick={() => setIsOpen(false)}
            >
              Home Inspections
            </Link>
            <Link data-zylo-id="zylo-3b20c5d4597f" data-zylo-kind="link" data-zylo-cap="26" data-zylo-file="src/components/navbar.tsx" data-zylo-loc="78:13-84:20" data-zylo-component="Navbar"
              href="/about"
              className="block py-2 text-foreground hover:text-primary transition-colors font-medium"
              onClick={() => setIsOpen(false)}
            >
              About
            </Link>
            <Link data-zylo-id="zylo-bb15f36e2cc4" data-zylo-kind="link" data-zylo-cap="26" data-zylo-file="src/components/navbar.tsx" data-zylo-loc="85:13-91:20" data-zylo-component="Navbar"
              href="/contact"
              className="block py-2 text-foreground hover:text-primary transition-colors font-medium"
              onClick={() => setIsOpen(false)}
            >
              Contact
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}
